import React from 'react';
// Styles
import styles from './style/drawerFooter.module.css';

function DrawerFooter({ children }:{ children: React.ReactNode }) {
  return (
    <footer className={styles.container}>
      { children }
    </footer>
  );
}

export default DrawerFooter;
